class PasswordChecker {
    constructor(pwd) {
        this.pwd = pwd;
        this.score = 4;

        this.checkScore();
    }

    getScore() {
        return this.score;
    }

    checkScore() {
        this.checkLength();
        this.checkLetters();
        this.checkNumber();
        this.checkSpecials();

        this.checkDuplicated();
    }

    checkLength() {
        if (this.pwd.length < 8) this.score -= 1;
        else this.checkLetters(true);
    }

    checkLetters(both = false) {
        let score = 0;

        if (this.pwd.match(/[A-Z]/g)) score += 1;
        if (this.pwd.match(/[a-z]/g)) score += 1;

        if (both && score < 2) this.score -= 1;
        else if (score < 1) this.score -= 1;
    }

    checkNumber() {
        if (!this.pwd.match(/[0-9]/g)) this.score -= 1;
    }

    checkSpecials() {
        if (!this.pwd.match(/[@#&!-$*%?/+]/g)) this.score -= 1;
    }

    checkDuplicated() {
        const duplicated = [];
        let isDuplicated = false;

        this.pwd.split('').forEach((letter) => {
            if (!duplicated[letter]) duplicated[letter] = 1;
            else if (duplicated[letter]) duplicated[letter] += 1;

            if (duplicated[letter] >= 3) isDuplicated = true;
        });

        if (isDuplicated) this.score -= 1;
    }
}

export default PasswordChecker;
